var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleLang + ' app'},[_c('el-backtop',{attrs:{"target":".app"}},[_c('div',{staticClass:"back-top",attrs:{"name":"el-fade-in"}})]),_c('myHeader'),_c('div',{attrs:{"id":"main"}},[_c('router-view')],1),_c('myFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }